<template>
  <div class="mission-ranking-table-section">
    <div class="mission-ranking-table-section__heading">
      <p class="mission-ranking-table-section__heading-ranking">
        {{ $tc('MissionPage.RankingPage.table.rank') }}
      </p>
      <p class="mission-ranking-table-section__heading-name">
        {{ $tc('MissionPage.RankingPage.table.name') }}
      </p>
      <p class="mission-ranking-table-section__heading-point">
        {{ $tc('MissionPage.RankingPage.table.point') }}
      </p>
    </div>
    <div class="mission-ranking-table-section__body">
      <ol class="mission-ranking-table-section__list">
        <li
          v-for="user in rankings"
          :key="user.userId"
          class="mission-ranking-table-section__item"
          :class="{ 'mission-ranking-table-section__item--self': checkIsOwnRank(user.userId) }"
        >
          <mission-ranking-table-item-parts
            :userData="user"
            :isOwnRank="checkIsOwnRank(user.userId) || false"
            :retrieveNameUsersByUserId="retrieveNameUsersByUserId"
            :rankingType="rankingType"
            @onClickSnsButton="onClickSnsButton"
            @onClickShareIcon="onClickShareIcon"
            @savePostSnsMissionHistory="$emit('savePostSnsMissionHistory')"
          />
        </li>
      </ol>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import MissionRankingTableItemParts from '@/components/MissionPage/MissionRankingPane/parts/MissionRankingTableItemParts.vue'
import { RankInUserType } from '@/store/stores/collectionModule/documents/pointRanking/PointRankingDataDocument'
import { UserRetrieveNameResponseType } from '@/store/stores/collectionModule/documents/user/UserRetrieveNameDocument'
import StoreUtil from '@/store/StoreUtil'
import LoginStore from '@/store/stores/loginStore/LoginStore'
import { RankingType } from '@/store/stores/pageStore/MissionPage/MissionPageStore'

export default defineComponent({
  name: 'MissionRankingTableSection',
  components: {
    MissionRankingTableItemParts,
  },
  props: {
    category: {
      type: String,
    },
    rankings: {
      type: Array as PropType<Array<RankInUserType>>,
      default: () => [],
    },
    retrieveNameUsersByUserId: {
      type: Object as PropType<Record<string, UserRetrieveNameResponseType>>,
    },
    rankingType: {
      type: String as PropType<RankingType>,
      default: 'TOTAL',
    },
  },
  setup(props) {
    const contractInfoStore = StoreUtil.useStore('ContractInfoStore')
    const { ownOrganization } = contractInfoStore

    // 自分が上位１０位以内にランクインしてるかどうか
    const checkIsOwnRank = (userId: string) => {
      if (!ownOrganization.value || !props.rankings) return false
      const ownUserId = LoginStore.value.userId || ''
      return userId === ownUserId
    }

    return {
      checkIsOwnRank,
    }
  },
  methods: {
    onClickSnsButton() {
      this.$emit('onClickSnsButton')
    },
    onClickShareIcon() {
      this.$emit('onClickShareIcon')
    },
  },
})
</script>

<style scoped lang="scss">
.mission-ranking-table-section {
  &__heading {
    display: flex;
    gap: 12px;
    padding: 10px;
    font-size: 13px;
    font-weight: 500;
    color: rgba(#fff, 0.7);
    letter-spacing: 0.04em;
    background-color: rgba(#757575, 0.9);

    &-name {
      flex-grow: 1;
      padding-left: 48px;
    }

    &-point {
      width: 70px;
      text-align: center;
    }
  }

  &__item {
    border-top: 1px solid $gray50;

    &--self {
      border-top: none;

      + .mission-ranking-table-section__item {
        border-top: none;
      }
    }
  }
}
</style>
